// import PersonIcon from "@material-ui/icons/Person";
import TextField from "@material-ui/core/TextField";

const TextFieldUser = ({childTK,stateHelper,stateDiss,onChangeUser,onKeypressToken}) => {
	return (
		<>
			{/* <PersonIcon color="primary" /> */}
			<TextField
				name="Token"
				inputRef={childTK}
				error={stateHelper.etk}
				disabled={stateDiss.dtk}
				autoFocus
				helperText={stateHelper.ttk}
				onChange={onChangeUser}
				onKeyPress={onKeypressToken}
				label="Token Acceso"
				style={{ width: "100%" }}
				variant="filled"
			/>
		</>
	);
};
export default TextFieldUser;